import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { AxiosError } from "axios";
import { updateProjectColumns } from "store/features/groupBy/groupBySlice";

import { ColumnModel, postUserDefinedColumn } from "api/data";

import { EntityKind } from "models/entityKind";

export function usePostUserDefinedColumnMutation(
  entityKind: EntityKind,
  isOrg: boolean,
  projectId?: string | null,
  onSuccess?: () => void,
  onError?: (error: AxiosError<{ error?: string; message?: string }>) => void
) {
  const dispatch = useDispatch();

  return useMutation(
    async (data: ColumnModel[]) => {
      return await postUserDefinedColumn(data, isOrg, projectId, entityKind);
    },
    {
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        }

        if (projectId) {
          dispatch(updateProjectColumns(entityKind));
        }

        toast.success("Successfully added fields.");
      },
      onError: (error: AxiosError<{ error?: string; message?: string }>) => {
        onError && onError(error);
      }
    }
  );
}
